import * as echarts from 'echarts'
import store from '../../../store'
export default {
    // 国内专利分析
    // 1.国内专利趋势
    domesticzl1ind: function () {
        let myChart = echarts.init(document.querySelector(".domesticzl1ind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                },
            },
            legend: {
                right: 50,
                icon: "rect",
                data: ['申请量', '授权量']
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
                // top:'-50%'
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: true,
                    data: store.state.trendTimeind,
                    axisLabel: {
                        fontSize: 12,
                        color: "#000",
                        show: true,
                        interval: 0
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#ddd",
                            width: 2
                        }
                    },
                    axisTick: {
                        show: false
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',

                    axisLabel: {
                        color: "#ddd",
                        fontSize: 12
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#ddd",
                            width: 2
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        lineStyle: {
                            color: "#ddd"
                        }
                    }
                }
            ],
            series: [
                {
                    name: '申请量',
                    type: 'line',
                    lineStyle: {
                        normal: {
                            color: '#E02020',
                            width: 2
                        }

                    },
                    color: '#E02020',
                    areaStyle: {
                        color: ' rgba(224, 32, 32,.3)',
                    },
                    smooth: true,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        color: "#000"
                    },
                 
                    data: store.state.trendApListYapplyind

                },
                {
                    name: '授权量',
                    type: 'line',
                    lineStyle: {
                        normal: {
                            color: '#6236FF',
                            width: 2
                        }
                    },
                    color: '#6236FF',
                    areaStyle: {
                        color: 'rgba(98, 54, 255,.3)'
                    },
                    smooth: true,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        color: "#000"
                    },
                  
                    data: store.state.trendApListYagreeind
                },
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 2.专利类型构成
    domesticzl2ind: function () {
        let myChart = echarts.init(document.querySelector(".domesticzl2ind"));
        let options = {
            tooltip: {
                trigger: 'item'
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            legend: {
                orient: 'vertical',
                left: 'left',
                icon: 'circle',
                top: 30,
                formatter: function (name) {
                    let values = []
                    let index = 0
                    store.state.apTyCountind.forEach((ele, i) => {
                        values.push(ele.value)
                        if (ele.name == name) {
                            index = i
                        }
                    })
                    return name + "：" + values[index]
                }
            },
            series: [
                {
                    type: 'pie',
                    radius: '50%',
                    data: store.state.apTyCountind,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    label: {
                        formatter: "{b}:{c}"
                    },
                    color: ['#73A0FA', '#73DEB3', '#FFAB67'],
                    radius: ['0', '80%'],
                    center: ['55%', '45%']
                }
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    domesticzl2sqind: function () {
        let myChart = echarts.init(document.querySelector(".domesticzl2sqind"));
        let options = {
            tooltip: {
                trigger: 'item'
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            legend: {
                orient: 'vertical',
                left: 'left',
                icon: 'circle',
                top: 30,
                formatter: function (name) {
                    let values = []
                    let index = 0
                    store.state.apTyAuthCountind.forEach((ele, i) => {
                        values.push(ele.value)
                        if (ele.name == name) {
                            index = i
                        }
                    })
                    return name + "：" + values[index]

                }
            },
            series: [
                {
                    type: 'pie',
                    radius: '50%',
                    data: store.state.apTyAuthCountind,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    label: {
                        formatter: "{b}:{c}"
                    },
                    color: ['#73A0FA', '#73DEB3', '#FFAB67'],
                    radius: ['0', '80%'],
                    center: ['55%', '45%']
                }
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 3.IPC技术分类top10
    domesticzl3ind: function () {
        let myChart = echarts.init(document.querySelector(".domesticzl3ind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                top: '8%',
                right: '3%',
                bottom: '2%',
                containLabel: true,
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    formatter: function () {
                        return "";
                    }
                }
            },
            yAxis: {
                type: 'category',
                axisTick: {
                    show: false
                },
                data: store.state.ipcCountYind,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    formatter: function (params) {
                        var val = ""
                        if (params.length > 10) {
                            val = params.substr(0, 10) + "..."
                            return val
                        } else {
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.ipcCountXind,
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#3370ed'
                            }, {
                                offset: 1,
                                color: '#94c2fd'

                            }])
                        }
                    },
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    domesticzl3sqind: function () {
        let myChart = echarts.init(document.querySelector(".domesticzl3sqind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                top: '8%',
                right: '3%',
                bottom: '2%',
                containLabel: true,
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    formatter: function () {
                        return "";
                    }
                }
            },
            yAxis: {
                type: 'category',
                axisTick: {
                    show: false
                },
                data: store.state.ipcAuthCountYind,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    formatter: function (params) {
                        var val = ""
                        if (params.length > 10) {
                            val = params.substr(0, 10) + "..."
                            return val
                        } else {
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.ipcAuthCountXind,
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#3370ed'
                            }, {
                                offset: 1,
                                color: '#94c2fd'

                            }])
                        }
                    },
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 4.专利分析榜单
    domesticzl4ind: function () {
        let myChart = echarts.init(document.querySelector(".domesticzl4ind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 20
            },
            grid: {
                left: '2%',
                top: '8%',
                right: '3%',
                bottom: '2%',
                containLabel: true,
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                show: true,
                axisTick: {
                    show: true,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.appTop10Yind,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    formatter: function (params) {
                        var val = ""
                        if (params.length > 10) {
                            val = params.substr(0, 10) + "..."
                            return val
                        } else {
                            return params
                        }
                    }

                },
                inverse: true

            },
            series: [
                {
                    type: 'bar',
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#5ba1ff'
                            }, {
                                offset: 1,
                                color: '#2dc9fd'

                            }])
                        }
                    },
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    data: store.state.appTop10Xind,
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    domesticzl4sqind: function () {
        let myChart = echarts.init(document.querySelector(".domesticzl4sqind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 20
            },
            grid: {
                left: '2%',
                top: '8%',
                right: '3%',
                bottom: '2%',
                containLabel: true,
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                show: true,
                axisTick: {
                    show: true,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.authTop10Yind,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    formatter: function (params) {
                        var val = ""
                        if (params.length > 10) {
                            val = params.substr(0, 10) + "..."
                            return val
                        } else {
                            return params
                        }
                    }
                },
                inverse: true

            },
            series: [
                {
                    type: 'bar',
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#5ba1ff'
                            }, {
                                offset: 1,
                                color: '#2dc9fd'

                            }])
                        }
                    },
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    data: store.state.authTop10Xind,
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    domesticzl4yxind: function () {
        let myChart = echarts.init(document.querySelector(".domesticzl4yxind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 20
            },
            grid: {
                left: '2%',
                top: '8%',
                right: '3%',
                bottom: '2%',
                containLabel: true,
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                show: true,
                axisTick: {
                    show: true,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.validTop10Yind,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    formatter: function (params) {
                        var val = ""
                        if (params.length > 10) {
                            val = params.substr(0, 10) + "..."
                            return val
                        } else {
                            return params
                        }
                    }
                },
                inverse: true,

            },
            series: [
                {
                    type: 'bar',
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#5ba1ff'
                            }, {
                                offset: 1,
                                color: '#2dc9fd'

                            }])
                        }
                    },
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    data: store.state.validTop10Xind,
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    domesticzl4wxind: function () {
        let myChart = echarts.init(document.querySelector(".domesticzl4wxind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 20
            },
            grid: {
                left: '2%',
                top: '8%',
                right: '3%',
                bottom: '2%',
                containLabel: true,
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                show: true,
                axisTick: {
                    show: true,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.notValidTop10Yind,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    formatter: function (params) {
                        var val = ""
                        if (params.length > 10) {
                            val = params.substr(0, 10) + "..."
                            return val
                        } else {
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    type: 'bar',
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#5ba1ff'
                            }, {
                                offset: 1,
                                color: '#2dc9fd'

                            }])
                        }
                    },
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    data: store.state.notValidTop10Xind,
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // PCT公开专利分析
    // 1.PCT专利趋势
    pctzl1ind: function () {
        let myChart = echarts.init(document.querySelector(".pctzl1ind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                },
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                top: '15%',
                right: '8%',
                bottom: '5%',
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                boundaryGap: true,
                // data:['2022','2021','2020','2019','2018'],
                data: store.state.trendTimeind,
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 10,
                    color: "#000",
                    interval:0
                },
            },
            yAxis: {
                type: 'value',
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000"
                },
            },
            series: [{
                name: '公开量',
                // data:[10,5,1,2,3],
                data: store.state.pctTrendCountYind,
                type: 'line',
                areaStyle: {
                    color: 'rgba(91, 143, 249,.3)'
                },
                label: {
                    show: true,
                    color: "#000",
                    position: 'top'
                },
                smooth: true,
                lineStyle: {
                    normal: {
                        color: '#5B8FF9',
                        width: 2
                    }

                },
            }]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 2.IPC分类Top10
    pctzl2ind: function () {
        let myChart = echarts.init(document.querySelector(".pctzl2ind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            legend: {
                right: 30,
                icon: 'rect'
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "15%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: false
                },

            },
            yAxis: {
                type: 'category',
                data: store.state.pctIpcTop10Yind,
                triggerEvent: true,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter: function (params) {
                        var val = ""
                        if (params.length > 10) {
                            val = params.substr(0, 10) + "..."
                            return val
                        } else {
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    name: '申请量',
                    type: 'bar',
                    data: store.state.pctIpcTop10Xind,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#5B8FF9'
                            }, {
                                offset: 1,
                                color: '#94C2FD'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 3.PCT公开量Top10
    pctzl3ind: function () {
        let myChart = echarts.init(document.querySelector(".pctzl3ind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: false
                },

            },
            yAxis: {
                type: 'category',
                data: store.state.pctTop10CountYind,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    
                },
                inverse: true
            },
            series: [
                {

                    type: 'bar',
                    data: store.state.pctTop10CountXind,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#18A069'
                            }, {
                                offset: 1,
                                color: '#81DB7C'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 专利状态分析
    // 1.专利状态分析
    statuszlind: function () {
        let myChart = echarts.init(document.querySelector(".statuszlind"));
        let options = {
            tooltip: {
                trigger: 'item'
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },

            legend: {
                orient: 'vertical',
                left: 'left',
                icon: 'circle',
                top: 40,
                left: 100,
                formatter: function (name) {
                    let values = []
                    let index = 0
                    store.state.ptLawCountind.forEach((ele, i) => {
                        values.push(ele.value)
                        if (ele.name == name) {
                            index = i
                        }
                    })
                    return name + "：" + values[index]
                }
            },
            series: [
                {

                    type: 'pie',
                    radius: '50%',
                    data: store.state.ptLawCountind,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    color: ['#5B8FF9', '#5AD8A6', '#5D7092', '#F6BD16', '#E8684A'],
                    radius: ['0', '75%'],
                    center: ['50%', '50%'],
                    label: {
                        formatter: "{b}:{c}"
                    },
                }
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 国内商标分析
    // 1.国内商标趋势
    domesticsb1ind: function () {
        let myChart = echarts.init(document.querySelector(".domesticsb1ind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                },
                // showContent:true
            },
            legend: {
                right: 50,
                icon: "rect",
                data: ['申请量', '注册量']
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
                // top:'-50%'
            },
            grid: {
                left: '2%',
                right: '6%',
                top: '15%',
                bottom: '2%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: true,
                    data: store.state.trendTimeind,
                    axisLabel: {
                        fontSize: 12,
                        color: "#000",
                        interval:0
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#ddd",
                            width: 2
                        }
                    },
                    axisTick: {
                        show: false
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',

                    axisLabel: {
                        color: "#ddd",
                        fontSize: 12
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#ddd",
                            width: 2
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        lineStyle: {
                            color: "#ddd"
                        }
                    }
                }
            ],
            series: [
                {
                    name: '申请量',
                    type: 'line',
                    lineStyle: {
                        normal: {
                            color: '#5B8FF9',
                            width: 2
                        }

                    },
                    color: '#5B8FF9',
                    areaStyle: {
                        color: 'rgba(91, 143, 249,.3)',
                    },
                    smooth: true,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        color: "#000"
                    },
                 
                    data: store.state.tmTrendMapY1ind

                },
                {
                    name: '注册量',
                    type: 'line',
                    lineStyle: {
                        normal: {
                            color: '#5AD8A6',
                            width: 2
                        }
                    },
                    color: '#5AD8A6',
                    areaStyle: {
                        color: 'rgba(90, 216, 166,.3)'
                    },
                    smooth: true,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        color: "#000"
                    },
                
                    data: store.state.tmTrendMapY2ind
                },
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 2.国际分类Top10
    domesticsb2ind: function () {
        let myChart = echarts.init(document.querySelector(".domesticsb2ind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.icTop10MapYind,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.icTop10MapXind,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#28BEAE'
                            }, {
                                offset: 1,
                                color: '#3EDDCC'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    domesticsb2zcind: function () {
        let myChart = echarts.init(document.querySelector(".domesticsb2zcind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.icRegTop10MapYind,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000"
                },
                inverse: true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.icRegTop10MapXind,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#28BEAE'
                            }, {
                                offset: 1,
                                color: '#3EDDCC'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 3.商标分析榜单
    domesticsb3ind: function () {
        let myChart = echarts.init(document.querySelector(".domesticsb3ind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.topApp10MapYind,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.topApp10MapXind,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#0396FF'
                            }, {
                                offset: 1,
                                color: '#75C5FE'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    domesticsb3zcind: function () {
        let myChart = echarts.init(document.querySelector(".domesticsb3zcind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.topReg10MapYind,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.topReg10MapXind,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#0396FF'
                            }, {
                                offset: 1,
                                color: '#75C5FE'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    domesticsb3yxind: function () {
        let myChart = echarts.init(document.querySelector(".domesticsb3yxind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.topValid10MapYind,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.topValid10MapXind,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#0396FF'
                            }, {
                                offset: 1,
                                color: '#75C5FE'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 马德里商标分析
    // 1.马德里商标趋势
    mdl1ind: function () {
        let myChart = echarts.init(document.querySelector(".mdl1ind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                },
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                top: '10%',
                right: '3%',
                bottom: '5%',
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                boundaryGap: true,
                data: store.state.trendTimeind,
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000"
                },
            },
            yAxis: {
                type: 'value',
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#ddd"
                },
            },
            series: [{
                name: '注册量',
                data: store.state.mdltrendYind,
                type: 'line',
                areaStyle: {
                    color: 'rgba(250, 100, 0,.3)'
                },
                color: '#FA6400',
                smooth: true,
                label: {
                    show: true,
                    color: "#000",
                    position: 'top'
                },
                lineStyle: {
                    normal: {
                        color: '#FA6400',
                        width: 2
                    }
                },
            }]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 2.马德里延伸国家TOP20
    mdl2ind: function () {
        let myChart = echarts.init(document.querySelector(".mdl2ind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            grid: {
                top: '15%',
                bottom: '8%',
                left: "5%",
                right: "3%",
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            xAxis: {
                type: 'category',
                data: store.state.mdltop20indX,
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2

                    }
                },
                axisLabel: {
                    color: "#000",
                    show: true
                },
                axisTick: {
                    show: false
                }
            },
            yAxis: {
                type: 'value',
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2

                    }
                }
            },
            series: [{
                name: '马德里注册量',
                data: store.state.mdltop20indY,
                type: 'bar',
                label: {
                    show: true,
                    color: "#000",
                    position: 'top'
                },
                itemStyle: {
                    normal: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: '#2DAFFD'
                        }, {
                            offset: 1,
                            color: '#1477FB'

                        }])
                    }
                },
                barMaxWidth:55
            }]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 3.马德里注册量Top10
    mdl3ind: function () {
        let myChart = echarts.init(document.querySelector(".mdl3ind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.mdlregindY,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                }
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.mdlregindX,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#FF6417'
                            }, {
                                offset: 1,
                                color: '#FF970C'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 商标状态分析
    // 1.商标状态分析
    statussbind: function () {
        let myChart = echarts.init(document.querySelector(".statussbind"));
        let options = {
            tooltip: {
                trigger: 'item'
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },

            legend: {
                orient: 'vertical',
                left: 'left',
                icon: 'circle',
                top: 40,
                left: 100,
                formatter: function (name) {
                    let values = []
                    let index = 0
                    store.state.lawMapind.forEach((ele, i) => {
                        values.push(ele.value)
                        if (ele.name == name) {
                            index = i
                        }
                    })
                    return name + "：" + values[index]
                }
            },
            series: [
                {

                    type: 'pie',
                    radius: '50%',
                    data: store.state.lawMapind,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    color: ['#5B8FF9', '#5AD8A6', '#5D7092'],
                    radius: ['0', '75%'],
                    center: ['50%', '50%'],
                    label: {
                        formatter: "{b}:{c}"
                    },
                }
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 商标运营分析
    // 1.商标转让趋势
    sbmani1ind: function () {
        let myChart = echarts.init(document.querySelector(".sbmani1ind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                },
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                top: '15%',
                right: '8%',
                bottom: '5%',
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                boundaryGap: true,
                data: store.state.trendTimeind,
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    interval:0
                },
            },
            yAxis: {
                type: 'value',
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000"
                },
            },
            series: [{
                name: '商标转让量',
                data: store.state.tmTransferMapYind,
                type: 'line',
                areaStyle: {
                    color: 'rgba(91, 143, 249,.3)'
                },
                label: {
                    show: true,
                    color: "#000",
                    position: 'top'
                },
                smooth: true,
                lineStyle: {
                    normal: {
                        color: '#5B8FF9',
                        width: 2
                    }

                },
            }]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 2.商标转让类别Top10
    sbmani2ind: function () {
        let myChart = echarts.init(document.querySelector(".sbmani2ind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "12%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true,
                    color: "#000"
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.tmIcTrfTopYind,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    name: '商标转让量',
                    type: 'bar',
                    data: store.state.tmIcTrfTopXind,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#1477FB'
                            }, {
                                offset: 1,
                                color: '#2DAFFD'
                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 3.商标许可趋势
    sbmani3ind: function () {
        let myChart = echarts.init(document.querySelector(".sbmani3ind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                },
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                top: '15%',
                right: '8%',
                bottom: '5%',
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                boundaryGap: true,
                data: store.state.trendTimeind,
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    interval:0
                },
            },
            yAxis: {
                type: 'value',
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000"
                },
            },
            series: [{
                name: '商标许可量',
                data: store.state.tmLicenseMapYind,
                type: 'line',
                areaStyle: {
                    color: 'rgba(250, 100, 0,.3)'
                },
                color: '#FA6400',
                label: {
                    show: true,
                    color: "#000",
                    position: 'top'
                },
                smooth: true,
                lineStyle: {
                    normal: {
                        color: '#FA6400',
                        width: 2
                    }

                },
            }]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 4.商标许可类别Top10
    sbmani4ind: function () {
        let myChart = echarts.init(document.querySelector(".sbmani4ind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "12%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true,
                    color: "#000"
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.tmIcLicTopYind,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse:true
            },
            series: [
                {
                    name: '商标许可量',
                    type: 'bar',
                    data: store.state.tmIcLicTopXind,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#FF9638'
                            }, {
                                offset: 1,
                                color: '#FFBC7F'
                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 5.商标质押趋势
    sbmani5ind: function () {
        let myChart = echarts.init(document.querySelector(".sbmani5ind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                },
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                top: '15%',
                right: '8%',
                bottom: '5%',
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                boundaryGap: true,
                data: store.state.trendTimeind,
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    interval:0
                },
            },
            yAxis: {
                type: 'value',
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000"
                },
            },
            series: [{
                name: '商标质押量',
                data: store.state.tmPledgeMapYind,
                type: 'line',
                areaStyle: {
                    color: 'rgba(39, 183, 99,.3)'
                },
                color: '#27B763',
                label: {
                    show: true,
                    color: "#000",
                    position: 'top'
                },
                smooth: true,
                lineStyle: {
                    normal: {
                        color: '#27B763',
                        width: 2
                    }

                },
            }]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 6.商标质押类别Top10
    sbmani6ind: function () {
        let myChart = echarts.init(document.querySelector(".sbmani6ind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "12%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true,
                    color: "#000"
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.tmIcPldTopYind,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse:true
            },
            series: [
                {
                    name: '商标质押量',
                    type: 'bar',
                    data: store.state.tmIcPldTopXind,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#37C973'
                            }, {
                                offset: 1,
                                color: '#68E6AB'
                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 7.商标运营分析榜单
    sbmani7ind: function () {
        let myChart = echarts.init(document.querySelector(".sbmani7ind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.tmTrfTop10Yind,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse:true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.tmTrfTop10Xind,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#1477FB'
                            }, {
                                offset: 1,
                                color: '#2DAFFD'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    sbmani7xkind: function () {
        let myChart = echarts.init(document.querySelector(".sbmani7xkind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.tmLicTop10Yind,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse:true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.tmLicTop10Xind,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#1477FB'
                            }, {
                                offset: 1,
                                color: '#2DAFFD'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    sbmani7zyind: function () {
        let myChart = echarts.init(document.querySelector(".sbmani7zyind"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.tmPldTop10Yind,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse:true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.tmPldTop10Xind,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#1477FB'
                            }, {
                                offset: 1,
                                color: '#2DAFFD'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
}